import {AfterViewInit, Component, HostListener, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {Customer} from '../../data/customer';
import {Tab} from '../../../tabbing/data/tab';
import {CustomerTooltip} from '../../data/customer.tooltip';
import {PhoneNumberFormatter} from '../../../app-common/utils/phonenumber.formatter';
import {NavigationService} from '../../../app-common/services/navigation.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {TabbingService} from "../../../tabbing/services/tabbing.service";
import {AppService} from "../../../app-common/services/app/app.service";

@Component({
  selector: 'app-customer-tooltip',
  templateUrl: './customer-tooltip.component.html',
  styleUrls: ['./customer-tooltip.component.css']
})
export class CustomerTooltipComponent implements OnInit, AfterViewInit {
  @Input() tab: Tab;
  @Input() tooltip: CustomerTooltip;

  positionStyle: SafeStyle;
  color: SafeStyle;

  constructor(public domSanitizer: DomSanitizer,
              public navigationService: NavigationService,
              private loggerService: LoggerService,

              public tabbingService: TabbingService,
              public appService: AppService) {
    this.domSanitizer = domSanitizer;
    this.navigationService = navigationService;
  }

  ngOnInit() {
    this.color = this.getCustomerColor(this.tooltip.dto);
    this.tooltip.dto.phoneNumber = PhoneNumberFormatter.getFormattedPhoneNumber(this.tooltip.dto.phoneNumber);

    const rect = this.tooltip.ref.nativeElement.getBoundingClientRect();
    if (rect.top < window.innerHeight / 2) {
      const style = 'position:fixed;' +
        'top:' + (rect.top - 2) + 'px;' +
        'left:' + (rect.left) + 'px;';
      this.positionStyle = this.domSanitizer.bypassSecurityTrustStyle(style);
    } else {
      const style = 'position:fixed;' +
        'top:' + (rect.bottom - 398) + 'px;' +
        'left:' + (rect.left) + 'px;';
      this.positionStyle = this.domSanitizer.bypassSecurityTrustStyle(style);
    }
  }

  onRightClick(event: any) {
    // this implements the instant closing when right-clicked again
    // after opening
    this.tooltip.rightClickPresses++;
    if (this.tooltip.rightClickPresses % 2 === 0) {
      this.tooltip.life = 0;
    } else {
      this.tooltip.life = 1;
    }
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CustomerTooltip, 'Right clicked on customer tooltip for customer:' + this.tooltip.dto.id);
  }

  ngAfterViewInit(): void {
  }

  @HostListener('window:resize')
  onWindowResize(): void {
  }


  getCustomerColor(user: Customer) {
    if (user === null || user === undefined) {
      return this.domSanitizer.bypassSecurityTrustStyle('');
    } else {
      const myrng = Math.random();
      const hue = myrng * 0.5 + 0.5;
      return this.domSanitizer.bypassSecurityTrustStyle(`filter: hue-rotate(${hue * 360}deg);`);
    }
  }

  navigate() {
    if (this.tabbingService.tabs.length >= 10 ){
      this.appService.showInfoMessage('Maximum tabs limit has been reached. Please close at lease 1 tab.');
    } else {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CustomerTooltip, 'Navigating to customer:' + this.tooltip.dto.id);
      this.navigationService.navigateInNewTab(['contacts', this.tooltip.dto.id.toString()]);
    }
  }
}
